/* CAMBIO selection companion for the Vitals device wishlist.
 * Vitals owns membership. This file never calls private Vitals APIs.
 * ARIS owns validation, current prices and linked cart lines.
 */
(() => {
  'use strict';
  const KEY = 'lb.wishlist.cambio.v1';
  const INPUT = 'input[type="checkbox"][field-name="CAMBIO Schnallen"][data-variant-id]';
  const lang = document.documentElement.lang.slice(0, 2);
  const strings = {
    de: ['CAMBIO Schnallen', 'Gespeicherter Gesamtpreis', 'Komplett in den Warenkorb', 'Gespeichertes Set öffnen', 'Dieses Set ist in diesem Browser gespeichert.', 'Das gespeicherte Set konnte nicht vollständig geladen werden. Bitte wählen Sie die Schnallen erneut.', 'Das Set wird geladen …', 'Bitte legen Sie gespeicherte Sets einzeln in den Warenkorb.', 'Das Set konnte nicht gespeichert werden. Bitte erlauben Sie den Browserspeicher.', 'Set aktualisiert.', 'Preise und Verfügbarkeit werden beim Öffnen erneut geprüft.'],
    en: ['CAMBIO buckles', 'Saved total price', 'Add complete set to cart', 'Open saved set', 'This set is saved in this browser.', 'The saved set could not be fully loaded. Please select your buckles again.', 'Loading your set …', 'Please add saved sets to the cart individually.', 'The set could not be saved. Please allow browser storage.', 'Set updated.', 'Prices and availability are checked again when opened.'],
    fr: ['Boucles CAMBIO', 'Prix total enregistré', 'Ajouter le lot complet au panier', 'Ouvrir le lot enregistré', 'Ce lot est enregistré dans ce navigateur.', 'Le lot enregistré n’a pas pu être chargé entièrement. Veuillez sélectionner les boucles à nouveau.', 'Chargement du lot …', 'Veuillez ajouter les lots enregistrés au panier individuellement.', 'Le lot n’a pas pu être enregistré. Veuillez autoriser le stockage du navigateur.', 'Lot mis à jour.', 'Les prix et la disponibilité sont revérifiés à l’ouverture.'],
    nl: ['CAMBIO gespen', 'Opgeslagen totaalprijs', 'Complete set in winkelwagen', 'Opgeslagen set openen', 'Deze set is in deze browser opgeslagen.', 'De opgeslagen set kon niet volledig worden geladen. Kies uw gespen opnieuw.', 'Uw set wordt geladen …', 'Voeg opgeslagen sets afzonderlijk toe aan de winkelwagen.', 'De set kon niet worden opgeslagen. Sta browseropslag toe.', 'Set bijgewerkt.', 'Prijzen en beschikbaarheid worden bij het openen opnieuw gecontroleerd.']
  };
  const t = strings[lang] || strings.en;
  const read = () => { try { const x = JSON.parse(localStorage.getItem(KEY) || '{}'); return x && typeof x === 'object' && !Array.isArray(x) ? x : {}; } catch (_) { return {}; } };
  const write = data => { localStorage.setItem(KEY, JSON.stringify(data)); };
  const valid = x => x && /^\d+$/.test(x.variant) && Array.isArray(x.buckles) && x.buckles.length > 0 && x.buckles.length <= 50 && x.buckles.every(b => /^\d+$/.test(b.id) && typeof b.name === 'string');
  const inputs = () => Array.from(document.querySelectorAll(INPUT));
  const variant = () => new URL(location.href).searchParams.get('variant') || document.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
  function message(text) {
    let el = document.querySelector('[data-lb-bundle-status]');
    if (!el) {
      el = document.createElement('p'); el.dataset.lbBundleStatus = ''; el.setAttribute('role', 'status');
      el.style.cssText = 'font-size:13px;line-height:1.5;margin:12px 0';
      const where = document.querySelector('.product__submit__buttons') || document.querySelector('main');
      where?.insertAdjacentElement('afterend', el);
    }
    if (el.textContent !== text) el.textContent = text;
  }
  function snapshot() {
    const id = variant();
    if (!id || !inputs().length) return null;
    const buckles = inputs().filter(x => x.checked).map(x => ({id: x.dataset.variantId, name: x.value}));
    const priceText = document.querySelector('.product__block__price')?.innerText.trim() || '';
    const price = priceText.match(/[€£$]\s*[\d.,]+|[\d.,]+\s*[€£$]/)?.[0] || priceText.split('\n')[0];
    return {variant: id, buckles, price, savedAt: Date.now()};
  }
  const savedText = text => /hinzugefügt|added|ajouté|toegevoegd/i.test(text);
  const same = (a, b) => JSON.stringify(a?.buckles?.map(x => x.id).sort()) === JSON.stringify(b?.buckles?.map(x => x.id).sort());
  function capture(event) {
    const button = event.target.closest?.('.lb-wishlist-anchor .Vtl-WishlistButton__AddToWishlist, .Vtl-WishlistIcon__ProductPageWrapper .Vtl-WishlistButton__WishlistIconButton');
    if (!button) return;
    const next = snapshot();
    if (!next) return;
    const data = read();
    // The image heart has no text; use the same product's native state.
    const nativeLabel = document.querySelector('.lb-wishlist-anchor .Vtl-WishlistButton__AddToWishlistText');
    const already = savedText(nativeLabel?.textContent || button.getAttribute('title') || button.textContent);
    if (already && !same(data[next.variant], next)) {
      // Updating a set must not toggle off the existing Vitals shoe entry.
      event.preventDefault(); event.stopImmediatePropagation();
      try { if (next.buckles.length) data[next.variant] = next; else delete data[next.variant]; write(data); message(t[9]); }
      catch (_) { message(t[8]); }
      return;
    }
    try {
      if (already || !next.buckles.length) delete data[next.variant]; else data[next.variant] = next;
      write(data);
    } catch (_) {
      if (next.buckles.length) { event.preventDefault(); event.stopImmediatePropagation(); message(t[8]); }
    }
    // Native Vitals success/failure remains authoritative; no fake success UI.
  }
  function setURL(href, record) {
    const url = new URL(href, location.origin);
    url.searchParams.set('lb_buckles', record.buckles.map(b => b.id).join(','));
    return url;
  }
  function recordFor(card) {
    if (card.closest('.vtl-proxy-page-share-wishlist')) return null;
    const a = card.querySelector('.Vtl-WishlistProduct__Link');
    if (!a) return null;
    const id = new URL(a.href).searchParams.get('variant');
    const record = read()[id];
    return valid(record) ? record : null;
  }
  function translateName(name) {
    const words = {
      en: [['Antik-Silber','Antique silver'],['Antik-Gold','Antique gold'],['Silber','Silver'],['Schwarz','Black'],['Multicolor','Multicolour'],['1 Paar','1 pair']],
      fr: [['Antik-Silber','Argenté antique'],['Antik-Gold','Doré antique'],['Silber','Argenté'],['Schwarz','Noir'],['Gold','Doré'],['Multicolor','Multicolore'],['1 Paar','1 paire']],
      nl: [['Antik-Silber','Antiek zilver'],['Antik-Gold','Antiek goud'],['Silber','Zilver'],['Schwarz','Zwart'],['Gold','Goud'],['1 Paar','1 paar']]
    };
    for (const [a,b] of words[lang] || []) name = name.replaceAll(a,b);
    return name;
  }
  let scheduled = false;
  function decorate() {
    scheduled = false; observer.disconnect();
    document.querySelectorAll('.Vtl-WishlistProduct').forEach(card => {
      const record = recordFor(card);
      if (!record) { card.querySelector('[data-lb-wishlist-set]')?.remove(); return; }
      const link = card.querySelector('.Vtl-WishlistProduct__Link');
      link.href = setURL(link.href, record).href;
      let box = card.querySelector('[data-lb-wishlist-set]');
      const signature = JSON.stringify([record.buckles, record.price, lang]);
      if (box && box.dataset.lbSetSignature !== signature) { box.remove(); box = null; }
      if (!box) {
        box = document.createElement('div'); box.dataset.lbWishlistSet = ''; box.dataset.lbSetSignature = signature;
        box.style.cssText = 'font-size:13px;line-height:1.5;padding:8px 4px;text-align:center;overflow-wrap:anywhere';
        link.insertAdjacentElement('afterend', box);
        const heading = document.createElement('strong'); heading.textContent = t[0]; box.append(heading);
        const list = document.createElement('ul'); list.style.cssText = 'margin:6px 0;padding:0;list-style:none';
        for (const b of record.buckles) { const li = document.createElement('li'); li.textContent = translateName(b.name); list.append(li); }
        box.append(list);
        const price = document.createElement('div'); price.textContent = t[1] + ': ' + record.price; box.append(price);
        const note = document.createElement('small'); note.textContent = t[4] + ' ' + t[10]; box.append(note);
      }
      const button = card.querySelector('.Vtl-WishlistProduct__AddToCartText');
      if (button) button.textContent = t[2];
    });
    const hasSets = Array.from(document.querySelectorAll('.Vtl-WishlistProduct')).some(recordFor);
    document.querySelectorAll('.Vtl-WishlistAddAllToCart').forEach(button => {
      if (hasSets) { button.hidden = true; button.dataset.lbSetBulkHidden = ''; }
      else if (button.hasAttribute('data-lb-set-bulk-hidden')) { button.hidden = false; delete button.dataset.lbSetBulkHidden; }
    });
    const bulk = document.querySelector('.Vtl-WishlistPage__AddAllWrapper');
    if (bulk) {
      let note = bulk.querySelector('[data-lb-set-bulk-note]');
      if (hasSets && !note) { note = document.createElement('small'); note.dataset.lbSetBulkNote = ''; note.textContent = t[7]; bulk.append(note); }
      if (!hasSets) note?.remove();
    }
    observer.observe(document.body, {childList: true, subtree: true});
  }
  const observer = new MutationObserver(() => { if (!scheduled) { scheduled = true; requestAnimationFrame(decorate); } });
  function wishlistClick(event) {
    const card = event.target.closest?.('.Vtl-WishlistProduct');
    const record = card && recordFor(card);
    if (record && event.target.closest('.Vtl-WishlistProduct__CloseButton')) {
      // Keep the companion if Vitals removal fails; clear only after its card disappears.
      const checkRemoval = () => {
        if (!card.isConnected) { const data = read(); delete data[record.variant]; try { write(data); } catch (_) {} }
      };
      setTimeout(checkRemoval, 1000); setTimeout(checkRemoval, 5000);
    }
    if (record && event.target.closest('.Vtl-WishlistProduct__AddToCart')) {
      event.preventDefault(); event.stopImmediatePropagation();
      const button = event.target.closest('.Vtl-WishlistProduct__AddToCart');
      if (button.disabled) return;
      const url = setURL(card.querySelector('.Vtl-WishlistProduct__Link').href, record);
      // One-shot intent is separate from the shareable product URL.
      try { sessionStorage.setItem('lb.wishlist.cart-intent', JSON.stringify({variant:record.variant, ids:record.buckles.map(b=>b.id), time:Date.now()})); }
      catch (_) { message(t[8]); return; }
      location.assign(url.href);
    }
    if (event.target.closest?.('.Vtl-WishlistAddAllToCart') && Array.from(document.querySelectorAll('.Vtl-WishlistProduct')).some(recordFor)) {
      event.preventDefault(); event.stopImmediatePropagation(); message(t[7]);
    }
  }
  function restore() {
    const url = new URL(location.href);
    if (!url.pathname.includes('/products/') || !url.searchParams.has('lb_buckles')) return;
    const ids = [...new Set(url.searchParams.get('lb_buckles').split(','))];
    if (!ids.length || ids.length > 50 || ids.some(x => !/^\d+$/.test(x))) { message(t[5]); return; }
    let intent = null;
    try { intent = JSON.parse(sessionStorage.getItem('lb.wishlist.cart-intent')); sessionStorage.removeItem('lb.wishlist.cart-intent'); } catch (_) {}
    const autoCart = intent && intent.variant === url.searchParams.get('variant') && Date.now()-intent.time < 60000 && JSON.stringify(intent.ids.slice().sort()) === JSON.stringify(ids.slice().sort());
    const deadline = Date.now()+20000;
    message(t[6]);
    function attempt() {
      const fields = inputs();
      if (!fields.length) {
        if (Date.now()<deadline) { setTimeout(attempt,200); return; }
        message(t[5]); return;
      }
      const wanted = ids.map(id=>fields.find(x=>x.dataset.variantId===id));
      if (wanted.some(x=>!x || x.disabled || x.dataset.stock === '0')) { message(t[5]); return; }
      // Dispatch the normal input click so ARIS updates its internal bundle too.
      fields.forEach(x=>{ if (x.checked !== ids.includes(x.dataset.variantId)) x.click(); });
      setTimeout(()=>{
        const checked = inputs().filter(x=>x.checked).map(x=>x.dataset.variantId).sort();
        if (JSON.stringify(checked)!==JSON.stringify(ids.slice().sort()) || variant()!==url.searchParams.get('variant')) { message(t[5]); return; }
        message(t[0]+': '+wanted.map(x=>translateName(x.value)).join(', '));
        if (autoCart) {
          const button = document.querySelector('.product__submit__buttons [data-add-to-cart]');
          if (!button || button.disabled) { message(t[5]); return; }
          // Use ARIS's existing cart handler and linked-line implementation.
          button.click();
        }
      }, 400);
    }
    attempt();
  }
  function start() {
    document.addEventListener('click', capture, true);
    document.addEventListener('click', wishlistClick, true);
    document.addEventListener('change', event => {
      if (event.target.matches?.(INPUT) && document.querySelector('[data-lb-bundle-status]')) {
        message(t[0] + ': ' + inputs().filter(x => x.checked).map(x => translateName(x.value)).join(', '));
      }
    });
    window.addEventListener('storage', decorate);
    decorate(); restore();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
